import React from 'react';
import gsap from 'gsap/gsap-core';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import classnames from 'classnames';

import styles from './Details.module.css';

import Typography from '../common/Typography';
import MediaComponent from '../common/MediaComponent';
import DetailPageRightPanel from './DetailsRightPanel';

import { NAVIGATION_FROM } from '../config/constants';
import translations from '../data';

const { general } = translations;

export default class DetailsComponent extends React.Component {
  constructor(props) {
    super(props);

    const { data, nextData } = this.props;

    this._isMobile =
      isMobile && typeof window !== 'undefined' && window.innerWidth < 1024;

    this.state = {
      currentData: data,
      productImage: this._isMobile ? data.imageMobile : data.imageLarge,
      dummyProductImage: this._isMobile
        ? nextData.imageMobile
        : nextData.imageLarge,
      nextProductImage: '',
    };
  }

  componentDidMount() {
    gsap.set('.dummy-image', { opacity: 0 });
    gsap.from('.current-image', { scale: 1.3, duration: 1 });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.nextData !== this.props.nextData) {
      this.setState({
        nextProductImage: this._isMobile
          ? this.props.nextData.imageMobile
          : this.props.nextData.imageLarge,
        dummyProductImage: this._isMobile
          ? this.props.nextData.imageMobile
          : this.props.nextData.imageLarge,
      });
    }
  }

  goBack() {
    const { back } = this.props;
    back();
  }

  showNextProduct(type, id) {
    const { getNextData } = this.props;

    const nextData = getNextData(type, id);

    const timeline = gsap.timeline({
      onComplete: () => {
        gsap.set('.gradient-overlay', { left: '100%' });

        gsap.set('.current-image', { xPercent: 0, opacity: 0 });

        gsap.set('.dummy-image', { opacity: 1 });

        gsap.set('.next-image', { xPercent: 0, maskPosition: '-100%, 0' });

        this.setState({
          productImage: this.state.nextProductImage,
        });
      },
    });
    // gradient
    timeline.to(
      '.gradient-overlay',
      { left: this._isMobile ? '-200%' : '-100%', duration: 1.2 },
      0,
    );

    // image animation
    timeline.from('.next-image', { xPercent: '20', duration: 1 }, 0);
    timeline.to(
      '.next-image',
      { xPercent: '0', maskPosition: '100%, 0', duration: 1 },
      0,
    );

    // change texts
    setTimeout(() => {
      this.setState({ currentData: nextData });
    }, 150);
  }

  render() {
    const { theme } = this.state.currentData;
    const { from } = this.props;

    const source = from === NAVIGATION_FROM.ROOM ? 'room' : 'timeline';

    return (
      <div className={styles.container}>
        <div className={`gradient-overlay ${styles.gradient}`} />
        {/* Braun logo left */}
        <MediaComponent
          image={require(`./assets/images/Braun-logo-${theme}.svg`)}
          className={styles.logo}
          alt="image"
          component="img"
          staticImage
        />
        {/* Braun logo right */}
        <MediaComponent
          image={require(`./assets/images/100-logo-black.svg`)}
          className={styles.logo100}
          alt="image"
          component="img"
          staticImage
        />
        <div className={styles.leftPanel}>
          <div className={styles.imageContainer}>
            {/* Current */}
            <MediaComponent
              image={this.state.productImage}
              srcset={this.state.productImage}
              className={`current-image ${styles.image}`}
              alt="image"
              component="img"
              onLoad={() => {
                gsap.set('.dummy-image', { opacity: 0 });
                gsap.set('.current-image', { opacity: 1 });
              }}
              staticImage
            />
            {/* Dummy */}
            <MediaComponent
              srcset={this.state.dummyProductImage}
              image={this.state.dummyProductImage}
              className={`dummy-image ${styles.image}`}
              alt="image"
              component="img"
              staticImage
            />
            {/* Next */}
            <MediaComponent
              image={this.state.nextProductImage}
              srcset={this.state.nextProductImage}
              className={`next-image ${styles.image}`}
              alt="image"
              component="img"
              staticImage
            />
          </div>

          <div
            className={styles.backContainer}
            onClick={() => {
              this.goBack();
            }}
          >
            <Typography
              className={classnames(styles[theme], styles.backMessage)}
              component="div"
              dangerouslySetInnerHTML={{
                __html: `${general.backTo} </br><b>${
                  from === NAVIGATION_FROM.ROOM
                    ? general.room
                    : general.timeline
                }</b>`,
              }}
            />
            <MediaComponent
              image={require(`./assets/images/${source}-back-${theme}.svg`)}
              className={styles.backIcon}
              alt="image"
              component="img"
              staticImage
            />
          </div>
        </div>
        <DetailPageRightPanel
          data={this.state.currentData}
          onClick={(type, id) => {
            this.showNextProduct(type, id);
          }}
        />
      </div>
    );
  }
}

DetailsComponent.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  nextData: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  from: PropTypes.string,
  back: PropTypes.func,
  getNextData: PropTypes.func,
};
